<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q6cRCF/tc-custom/9781497653085.jpg?1698195342226" alt="This image is the cover for the book Falling Torch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Falling Torch
      </h1>
      <p class="bookDescription body article font2">
        <b>Twenty years after Earth is conquered by invaders from space, the exiled US government has a chance to reclaim their lost planet </b><br/><br/> 2513 AD. For the past generation, since Earth was taken over by the Invaders, the US president and his cabinet have lived in exile on a planet in orbit around faraway Alpha Centauri. The Centaurian colony has become the center of the human race, reducing Earth to a backwater region in a sprawling foreign domain. But the banished American leaders still have a powerful yearning to return home. Now, President Ralph Wireman and his government finally have the financial aid and weaponry needed to retake their native planet. Wireman’s son, Michael, is parachuted to Earth as a Free Terrestrial, where the military-trained warrior is thrust into battle not between human and alien, but among factions of outlaw earthlings who demand nothing less than his total surrender.<br/>  <br/> A novel about war, politics, and assimilation, <i>Falling Torch </i>also presents an incisive portrait of one man’s aspirations of greatness and leadership.<br/><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Algis Budrys
      </h2>
      
      <p class="authorDescription body article">Algis Budrys (1931&ndash;2008) was born in K&ouml;nigsberg, East Prussia, where his father served in the Lithuanian diplomatic corps. The family came to the United States when Budrys was five years old. A Renaissance man, he wrote stories and novels, and was an editor, critic, and reviewer, a teacher of aspiring writers, and a publisher. In the 1960s Budrys worked in public relations, advertising products such as pickles, tuna fish, and four-wheel-drive vehicles. His science fiction novels include <I>Rogue Moon</I>,<I> Hard Landing</I>,<I> Falling Torch</I>, and many others. His Cold War science fiction thriller <I>Who? </I>was adapted for the screen, and he received many award nominations for his work. Budrys was married to his wife, Edna, for almost fifty-four years.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eafec4ce